function getSessionId() {
  let sessionId = sessionStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("sessionId", sessionId);
  }
  return String(sessionId);
}

function isMobileDevice() {
  if (window.innerWidth <= 768) {
    return "mobile";
  } else return "desktop";
}

function detectPlatform() {
  const userAgent = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
  if (/Android/i.test(userAgent)) return "Android";
  if (/Windows/i.test(userAgent)) return "Windows";
  if (/Macintosh|Mac OS X/i.test(userAgent)) return "macOS";
  return "Unknown Platform";
}

function addtocart(sessionId) {
  let list = JSON.parse(sessionStorage.getItem("cartlist"));
  let productlist = JSON.parse(sessionStorage.getItem("productlist"));
  if (productlist) {
    const productId = productlist[productlist.length - 1];
    if (!list) {
      list = [];
    }
    if (!list.includes(productId) && productlist.includes(productId)) {
      list.push(productId);
      track("add_to_cart", productId, sessionId, platform, device);
      sessionStorage.setItem("cartlist", JSON.stringify(list));
      console.log("cart product list : ", list);
    }
  }
}

function addproduct(category, productId, sessionId) {
  let list = JSON.parse(sessionStorage.getItem("productlist"));
  if (!list) {
    list = [];
  }
  if (!list.includes(productId)) {
    list.push(productId);
    track(category, productId, sessionId, platform, device);
    sessionStorage.setItem("productlist", JSON.stringify(list));
    console.log("product list : ", list);
  }
}

function track(eventType, productId, sessionId, platform, device) {
  const TrackingData = {
    event_type: eventType,
    product_id: productId,
    session_id: sessionId,
    timestamp: new Date().toISOString(),
    platform,
    device,
  };
  return fetch(
    "https://asia-south1-plasma-renderer-442106-m5.cloudfunctions.net/clicks-tracking-freakins",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "32dda1f3-c81c-452a-b583-372c38dec7a6",
      },
      body: JSON.stringify(TrackingData),
    }
  )
    .then((response) => {
      response.json();
      console.log("correct track");
    })
    .catch((error) => console.error("Tracking Error:", error));
}

const sessionId = getSessionId();
const device = isMobileDevice();
const platform = detectPlatform();
const productinviewId = document.querySelector("body").getAttribute("data-pid");

const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.hasAttribute("data-tracked")) {
        let list = JSON.parse(sessionStorage.getItem("productlist"));
        // if (list) {
        console.log("view tracked");
        track("viewed", productinviewId, sessionId, platform, device);
        // }
        entry.target.setAttribute("data-tracked", "true");
        observer.unobserve(entry.target);
      }
    });
  },
  {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  }
);

const targetElement = document.querySelector(
  ".custom_app_widgets"
);
if (targetElement) {
  observer.observe(targetElement);
}

document.querySelectorAll("product-item").forEach((element) => {
  element.addEventListener("click", (event) => {
    const item = event.target;
    const productItem = item.closest("product-item");
    const addToCartButton = item.closest(
      "button[data-product-add-to-cart-button]"
    );
    if (addToCartButton && productItem) {
      addtocart(sessionId);
      return;
    }
    if (item && item.closest) {
      const clickedproduct = item.closest("product-item");
      if (clickedproduct) {
        const productId = clickedproduct.getAttribute("data-pid");
        const category = clickedproduct
          .closest(".custom_app_widgets[data-pid]")
          .getAttribute("data-section");
        addproduct(category, productId, sessionId);
      }
    }
  });
});

document.querySelectorAll("[data-product-add-to-cart-button]").forEach((element) => {
  element.addEventListener("click", (event) => {
    const item = event.target;
    console.log("addtocart: ", item);
    addtocart(sessionId);
    event.stopPropagation();
  });

});